var InstallmentCalculatorEshop = function () {
    this.el = $('.initInstallmentCalculatorEshop');
    this.installments = null;
};

InstallmentCalculatorEshop.prototype.init = function () {
    var self = this;

    if (self.el.length) {

        self.installments = JSON.parse(JSON.stringify(self.el.data('installments')));
        self.changePrice(false);

        self.el.find('.changePrice').click(function () {
            self.changePrice(true);
        });

        $(".form-check-container-installment").off('click').on('click', function () {
            $('.installment-calc-iplatba').hide();
            $('.installment-calc-lcs').hide();
            $('.installment-calc').hide();

            if ($(this).hasClass('show-installment-calc') && $(this).find('input').is(':checked')) {
                $('.installment-calc').show();
                self.saveFinancing($(this).data('link2'));
            } else {
                $('.installment-calc').hide();
            }

            if ($(this).hasClass('show-installment-calc-iplatba') && $(this).find('input').is(':checked')) {
                $('.installment-calc-iplatba').show();
            } else {
                $('.installment-calc-iplatba').hide();
            }

            if ($(this).hasClass('show-installment-calc-lcs') && $(this).find('input').is(':checked')) {
                $('.installment-calc-lcs').show();
            } else {
                $('.installment-calc-lcs').hide();
            }

            if ($(this).hasClass('show-installment-calc') && $(this).find('input').is(':checked')) {
            } else {
                disabledAnimateAjax = true;
                $.nette.ajax($(this).data('link2'));
            }
        });
    }
};

InstallmentCalculatorEshop.prototype.changePrice = function (saveFinancingClick) {
    var self = this;
    var advancePayment = $(".calcAdvancePayment:checked").val();
    var installmentCount = $(".calcInstallmentCount:checked").val();

    var re = '\\d(?=(\\d{' + 3 + '})+$)';

    var installmentPrice = self.installments[advancePayment][installmentCount];
    self.el.find('.calcPrice').val(installmentPrice);
    var installmentPriceFormated = installmentPrice.toFixed(0).replace(new RegExp(re, 'g'), '$& ') + ' Kč';
    self.el.find('.calcPriceText').html(installmentPriceFormated);

    if (saveFinancingClick) {
        self.saveFinancing(null);
    }
};

InstallmentCalculatorEshop.prototype.saveFinancing = function (changePaymentTypeLink) {
    var self = this;
    var advancePayment = $(".calcAdvancePayment:checked").val();
    var installmentCount = $(".calcInstallmentCount:checked").val();
    var installmentPrice = self.installments[advancePayment][installmentCount];

    // console.log(advancePayment);
    // console.log(installmentCount);
    // console.log(installmentPrice);
    // return;
    disabledAnimateAjax = true;

    if (changePaymentTypeLink){
        $.nette.ajax(changePaymentTypeLink).done(function (){
            $.nette.ajax({
                type: 'GET',
                url: $('.show-installment-calc').data('link'),
                data: {
                    'advancePayment': advancePayment,
                    'installmentCount': installmentCount,
                    'installmentPrice': installmentPrice
                }
            });
        });
    }else{
        $.nette.ajax({
            type: 'GET',
            url: $('.show-installment-calc').data('link'),
            data: {
                'advancePayment': advancePayment,
                'installmentCount': installmentCount,
                'installmentPrice': installmentPrice
            }
        });
    }
};